export class ResidualPartner {
  id: string;
  name: string;
  brands: string[];

  constructor(p: Partial<ResidualPartner>) {
    this.id = p.id || '';
    this.name = p.name || '';
    this.brands = p.brands || [];
  }
}
